import React, { useEffect, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./profilepicture.css";
import Button from "../../../../../components/button";
import { toast } from "react-toastify";
//services
import {
  getVerifyToken,
  updateProfilePicture,
  updateVerifyToken,
  verifyCalendar,
} from "../../../../../services/medium";
import { useDispatch, useSelector } from "react-redux";
import { requestScreenNameChange } from "../../../../../services/profile";
import { setProfileImage } from "../../../../../reducer/userSlice";
import { Link, useParams } from "react-router-dom";
import { copyToClipboard } from "../../../../../utils/helpers";
import ProfilePopUp from "../profilePopup";
//import moment from "moment";
//import { da } from "date-fns/locale";

const defaultSrc =
  "https://lh3.googleusercontent.com/i7cTyGnCwLIJhT1t2YpLW-zHt8ZKalgQiqfrYnZQl975-ygD_0mOXaYZMzekfKW_ydHRutDbNzeqpWoLkFR4Yx2Z2bgNj2XskKJrfw8";

export default function ProfilePicture({ mediumship_level_admin, URL = "" }) {
  const dispatch = useDispatch();
  const params = useParams();
  const { profile_image, encoded_image, encrypted_id, id } = useSelector(
    (state) => state.user.user
  );
  const [image, setImage] = useState(defaultSrc);
  const [cropData, setCropData] = useState("#");
  const [cropper, setCropper] = useState();
  const [popup, setPopup] = useState(false);
  //const [message, setMessage] = useState("");
  //const [selectedFile, setselectedFile] = useState(null);
  const [copy, setCopy] = useState(false);
  const [copy1, setCopy1] = useState(false);
  const [copy2, setCopy2] = useState(false);
  const [showVerified, setShowVerified] = useState(false);

  useEffect(() => {
    getVerifyToken(id)
      .then((data) => {
        if (data.data.status) {
          console.log(data.data.data);
          setShowVerified(data.data.data.is_verify_token === 1  || data.data.data.is_verify_token === 2? true : false)

        }
      })
      .catch(() => { });
  }, []);

  const copyText = (e, value) => {
    let location = window.location.origin;
    let url = `${location}/embeded/${encrypted_id}`;
    setCopy(true);
    e.stopPropagation();
    copyToClipboard(`<iframe width="100%" height="320"  src="${url}"  />`);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };
  
const openBadgePopup = () => {
  window.loadModal2("#profile-popup-verified-badge", "show");
}
  
 
  const copyText1 = (e, value) => {
    let location = window.location.origin;
    let url = `${location}/embeded-code/${encrypted_id}`;
    setCopy1(true);
    e.stopPropagation();
    copyToClipboard(url);
    setTimeout(() => {
      setCopy1(false);
    }, 3000);
  };
  useEffect(() => {
    setImage(encoded_image);
  }, [profile_image]);

  const closePopup = () => setPopup(false);
  const openPopup = () => {
    setPopup(true);
  };

  const MAX_SIZE_MB = 2;
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
  const sizeErrorMessage = (bytes) =>
    `Your image is ${(bytes / (1024 * 1024)).toFixed(2)} MB. Profile picture must be ${MAX_SIZE_MB} MB or less. Please resize or compress it, or send it to support@verysoul.com.`;

  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const file = files && files[0];
    if (e.target) e.target.value = ""; // allow re-selecting the same file
    if (!file) return;

    // if (!file.type.startsWith("image/")) {
    //   toast.error("Please choose an image file (JPG, PNG, GIF or WEBP).", { position: "top-center" });
    //   return;
    // }
    if (file.size > MAX_SIZE_BYTES) {
      toast.error(sizeErrorMessage(file.size), { position: "top-center" });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const getCropData = () => {
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas({
      // Profile photos are shown at ~130px; 400px keeps them sharp on
      // retina screens while keeping the file around 30-60 KB.
      maxWidth: 400,
      maxHeight: 400,
      fillColor: "#fff",
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });
    if (!canvas) return;
    setCropData(canvas.toDataURL());

    // Re-encode the crop, lowering JPEG quality until it fits within the limit
    const qualities = [0.92, 0.85, 0.75, 0.65, 0.5];
    const tryEncode = (i) => {
      canvas.toBlob((blob) => {
        if (!blob) return;
        if (blob.size > MAX_SIZE_BYTES) {
          if (i + 1 < qualities.length) return tryEncode(i + 1);
          toast.error(sizeErrorMessage(blob.size), { position: "top-center" });
          return;
        }
        const file = new File([blob], "profile.jpg", { type: "image/jpeg" });
        updalodaImage(file);
      }, "image/jpeg", qualities[i]);
    };
    tryEncode(0);
  };

  const updalodaImage = (file) => {
    // setImage(file);
    const formData = new FormData();
    formData.append(profile_image === null ? "image" : "profile_image", file);
    if (profile_image !== null) {
      formData.append("type", "profile_image");
      requestScreenNameChange(formData).then((data) => {
        if (data.data.status) {
          closePopup();
          toast.success("Requested succesfully", { position: "top-center" });
        }
      });
    } else {
      updateProfilePicture(formData)
        .then((data) => {
          dispatch(setProfileImage(data.data.data.image));
          toast.success("Updated succesfully", { position: "top-center" });
        })
        .catch(() => { });
    }
  };
const handleRedirect = () => {
  // Redirect to the URL submission page with the token
  window.open(
    URL,
    "_blank"
  );
};
  return (
    <div className="row-one-step">
      <>
        {(parseInt(mediumship_level_admin) === 3 ||
          parseInt(mediumship_level_admin) === 6 ||
          parseInt(mediumship_level_admin) === 7) && (
            <>
              {" "}
              <div className="d-flex align-items-center justify-content-end pointer">
                <Link
                  className="public-profile-btn"
                  to={`/public-view`}
                  target="_blank"
                >
                  View Public Profile
                </Link>
              </div>
              <div className="d-flex align-items-center justify-content-end pointer mt-2">
                <div>
                  <Button
                    status={0}
                    type="button"
                    className={`resend-btn w-unset height-45 min-width-130px`}
                    onClick={copyText}
                    title={copy ? "Copied" : "Copy Embedded"}
                  />
                </div>
              </div>
              
            </>
          )}
           {(parseInt(mediumship_level_admin) === 2 || parseInt(mediumship_level_admin) === 3 || 
           parseInt(mediumship_level_admin) === 5 ||
          parseInt(mediumship_level_admin) === 6 ||
          parseInt(mediumship_level_admin) === 7 ||
          parseInt(mediumship_level_admin) === 8) && (
            <>
          <div className="d-flex align-items-center justify-content-end pointer mt-2">
              
                <div>
                  <Button
                    status={0}
                    type="button"
                    className={`resend-btn w-unset height-45 min-width-130px`}
                    onClick={copyText1}
                    title={copy1 ? "Copied" : "Copy Guest Link"}
                  />
                </div>
              </div>
              </>
          )}
        {showVerified &&
          <div className="d-flex align-items-center justify-content-end pointer mt-2">
            <div>
              <Button
                status={0}
                type="button"
                className={`resend-btn w-unset height-45 min-width-130px red-outline`}
                onClick={openBadgePopup}
                title={copy2 ? "Copied" : "Copy Verified Badge"}
              />
            </div>
          </div>}
          {/* <div className="d-flex align-items-center justify-content-end pointer mt-2">
            <div>
              <Button
                status={0}
                type="button"
                className={`resend-btn w-unset height-45 min-width-130px`}
                onClick={handleRedirect}
                title={"Submit URL"}
              />
            </div>
          </div> */}

        {/* <iframe src={'http://localhost:3000/my-profile'} /> */}
        <div className="d-flex align-items-center">
          <div className="profile-pic-new">
            <img
              className="main-profile-image"
              id="main-profile-image"
              src={
                profile_image !== null
                  ? `${process.env.REACT_APP_IMAGE_URL}${profile_image}`
                  : "images/user-dummy.png"
              }
            />
          </div>
          <div className="ml-2">
            {/* <span class="cropper-btn-file resend-btn w-unset height-45 min-width-130px">
                            {profile_image === null ? "Upload" : "Request Change"}<input type="file" onChange={onChange} />
                        </span> */}
            <Button
              status={0}
              type="button"
              className={`resend-btn w-unset height-45 min-width-130px`}
              onClick={openPopup}
              // title={requestChangePhoneNo ? "Submit" : "Request Change"}
              title={"Request Change"}
            />
            {/* {toast.success(message, { position: "top-center" })} */}
            {/* <span className="green font-size-11 d-block mt-1"> {message}</span> */}
          </div>

          {popup && (
            <div className="cropper-wrapper">
              <div className="cropper-container-inner">
                <span class="cropper-btn-file resend-btn w-unset height-45 min-width-130px">
                  Choose Image...
                  <input type="file" onChange={onChange} />
                </span>
                  <p className="image-note">
  <strong>Note:</strong> Your profile picture needs to be 2 MB or less. 
  If your file is<br/> larger, you can reduce its size by resizing or compressing it, 
  or <br/> send it to support@verysoul.com.
</p>

                <Cropper
                  style={{
                    height: 400,
                    width: 500,
                    backgroundColor: "gray",
                    opacity: 1,
                  }}
                  zoomTo={0.1}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={image}
                  dragMode="move"
                  viewMode={1}
                  minCropBoxHeight={10}
                  minCropBoxWidth={10}
                  background={true}
                  responsive={true}
                  rounded={true}
                  autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropper(instance);
                  }}
                  guides={true}
                />
              
                <Button
                  status={0}
                  type="button"
                  className={`resend-btn w-unset height-45 min-width-130px mt-1 pointer`}
                  onClick={getCropData}
                  // title={requestChangePhoneNo ? "Submit" : "Request Change"}
                  title={"Upload"}
                />
                <Button
                  status={0}
                  type="button"
                  className={`resend-btn w-unset height-45 min-width-130px ml-2 mt-1 pointer`}
                  onClick={closePopup}
                  // title={requestChangePhoneNo ? "Submit" : "Request Change"}
                  title={"Cancel"}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="pfil-name">
                    <img style={{ width: "100%" }} src={cropData} alt="cropped" />
                </div> */}
      </>
      <ProfilePopUp id={id} />
    </div >
  );
}
